<template>
  <main class="main page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <form @submit.prevent="submit" class="content">
            <div class="content__head">
              <div class="head__title title">Buy Cryptocurrency</div>
              <div class="head__refresh"></div>
            </div>

            <div class="content__container">
              <div class="checkout-step-list">
                <div class="checkout-step-list__item">
                  <div class="checkout-step__title title">
                    01. Payment method
                  </div>

                  <div class="payment-methods-list">
                    <button class="button gradient payment-methods-list__item">
                      <div class="button__wrapper">Card method</div>
                    </button>
                  </div>
                </div>
                <div class="checkout-step-list__item">
                  <div class="checkout-step__title title">
                    02. Input your wallet
                  </div>
                  <div class="checkout-step__desc desc">
                    Please specify the wallet you`d like to recieve
                    cryptocurrency.
                  </div>

                  <input
                    v-model="wallet"
                    required
                    placeholder="Enter wallet number"
                    type="text"
                    class="checkout-step__input"
                  />
                </div>
                <div class="checkout-step-list__item">
                  <div class="checkout-step__title title">
                    03. Order summary
                  </div>
                  <div class="checkout-step__conversion">
                    <div class="take-amount title">
                      {{ this.$parent.giveAmount }}
                      {{ this.$parent.giveCurrency.symbol }}
                    </div>
                    <div class="give-amount title small">
                      For {{ this.$parent.takeAmount }}
                      {{
                        this.$parent.takeCurrency.crypto_currency.toUpperCase()
                      }}
                    </div>
                  </div>
                  <div class="checkout-step__conversion_details">
                    <div class="conversion_detail">
                      <div class="conversion_detail__title desc">
                        Price ({{
                          this.$parent.takeCurrency.crypto_currency.toUpperCase()
                        }}/{{ this.$parent.giveCurrency.code }})
                      </div>
                      <div class="conversion_detail__value title">
                        {{ this.$parent.takeCurrency.price }} €
                      </div>
                    </div>
                    <div class="conversion_detail">
                      <div class="conversion_detail__title desc">Date/time</div>
                      <div class="conversion_detail__value title">
                        {{
                          new Intl.DateTimeFormat("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          }).format(this.$parent.orderDateTime)
                        }}
                        <br />
                        {{
                          new Intl.DateTimeFormat("en-GB", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          }).format(this.$parent.orderDateTime)
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="notice">
                <div class="notice__wrapper">
                  <div class="title">Important notice</div>
                  <div class="desc">
                    Please double check your wallet information before making a
                    payment to ensure that your funds reach the correct
                    destination and to avoid any potential delays or loss of
                    funds.
                  </div>
                </div>
              </div>

              <div class="actions">
                <div class="actions__rules">
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input v-model="agree" type="checkbox" name="terms" />
                        <div class="checkbox"></div>
                        <span class="desc">
                          I have read and agreed to the
                        </span>
                        <a @click="$parent.goToTerms()" class="desc link">
                          Terms and Conditions</a
                        >
                      </div>
                    </label>
                  </div>
                </div>

                <div class="actions__buttons">
                  <router-link :to="{ name: 'BuyCrypto' }" class="button gray">
                    Go Back
                  </router-link>

                  <button
                    :disabled="!agree || !wallet"
                    type="submit"
                    :class="['button', { disabled: !agree || !wallet }]"
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>

            <!--            <div class="card-list">-->
            <!--              <template v-if="!$parent.checkoutSuccess" >-->
            <!--              <div class="card-list__item order-details">-->
            <!--                <div class="title small">Order details</div>-->
            <!--                <div class="desc">Choose payment method:</div>-->
            <!--                <div class="radio-list">-->
            <!--                  <div class="list">-->
            <!--                    <div class="item"></div>-->
            <!--                    <div class="item">-->
            <!--                      <label>-->
            <!--                        <input v-if="$parent.fiatToCrypto" type="radio" v-model="$parent.paymentMethod" name="paymentMethod" value="card"/>-->
            <!--                        <input v-else type="radio" v-model="$parent.paymentMethod" name="paymentMethod" value="crypto"/>-->
            <!--                        <div class="text">-->
            <!--                          <svg v-if="$parent.fiatToCrypto" class="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.667 17.841">-->
            <!--                            <g id="Layer_1" transform="translate(-2.13 -5.896)">-->
            <!--                              <path id="Контур_12558" data-name="Контур 12558" d="M6.467,23.737h16A4.338,4.338,0,0,0,26.8,19.4V10.229A4.338,4.338,0,0,0,22.464,5.9h-16a4.338,4.338,0,0,0-4.333,4.333v1.544c0,.008,0,.014,0,.021s0,.014,0,.021V19.4a4.338,4.338,0,0,0,4.333,4.333Zm16-1.766h-16A2.57,2.57,0,0,1,3.9,19.4V12.678H25.031V19.4A2.57,2.57,0,0,1,22.464,21.972Zm-16-14.31h16a2.57,2.57,0,0,1,2.567,2.567v.683H3.9v-.683A2.57,2.57,0,0,1,6.467,7.662Z" transform="translate(0 0)" fill="#7f8798"/>-->
            <!--                              <path id="Контур_12559" data-name="Контур 12559" d="M10.865,20.469H6.737a.883.883,0,1,0,0,1.766h4.128a.883.883,0,0,0,0-1.766Z" transform="translate(-0.436 -1.707)" fill="#7f8798"/>-->
            <!--                            </g>-->
            <!--                          </svg>-->
            <!--                          <div class="desc">{{ $parent.fiatToCrypto ? 'Visa/Mastercard' : 'Crypto' }} </div>-->
            <!--                        </div>-->
            <!--                      </label>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--                <div class="input-container">-->
            <!--                  <div class="desc">Wallet:</div>-->
            <!--                  <input type="text" v-model="wallet"/>-->
            <!--                  <div class="clue">The wallet you'll pay from</div>-->
            <!--                </div>-->
            <!--                <div class="total">-->
            <!--                  <div class="desc">Total amount to pay:</div>-->
            <!--                  <div class="total-wrapper">-->
            <!--                    <div class="item">-->
            <!--                      <div class="text">-->
            <!--                        <div class="desc">Date of order</div>-->
            <!--                        <div class="desc">{{currentDate}}</div>-->
            <!--                      </div>-->
            <!--                      <div class="title" :class="{'crypto': !$parent.fiatToCrypto}">{{ leftAmount }}</div>-->
            <!--                    </div>-->
            <!--                    <div class="item">-->
            <!--                      <div class="text">-->
            <!--                        <div class="desc">Exchange rate</div>-->
            <!--                        <div class="desc">{{$parent.takeCurrency.crypto_currency}} = {{$parent.takeCurrency.price}} {{$parent.giveCurrency.symbol}}</div>-->
            <!--                      </div>-->
            <!--                      <div class="title" :class="{'crypto': $parent.fiatToCrypto}">{{ rightAmount }}</div>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--                <div class="total-bottom">-->
            <!--                  <router-link to="buy-crypto" class="button gray">Cancel order</router-link>-->
            <!--                  <button class="button" :disabled="!wallet" @click="submit">Continue</button>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--              <div class="card-list__item-container">-->
            <!--                <div class="card-list__item your-card">-->
            <!--                  <div class="title small">Your Card</div>-->
            <!--                  <div class="row">-->
            <!--                    <div class="title">{{ leftAmount }}</div>-->
            <!--                    <router-link to="buy-crypto" class="button gray">Change amount</router-link>-->
            <!--                  </div>-->
            <!--                  <div class="desc">{{ rightAmount }}</div>-->
            <!--                  <div class="table">-->
            <!--                    <div class="row">-->
            <!--                      <div class="desc">Exchange rate</div>-->
            <!--                      <div class="desc">1 {{$parent.takeCurrency.crypto_currency}} = {{$parent.takeCurrency.price}} {{$parent.giveCurrency.symbol}}</div>-->
            <!--                    </div>-->
            <!--                    <div class="row">-->
            <!--                      <div class="desc">{{ $parent.fiatToCrypto ? 'Coins' : 'Money' }} to receive</div>-->
            <!--                      <div class="desc">{{ rightAmount }}</div>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--                <div class="timer">-->
            <!--                  <div class="title">{{ hours }}:{{ minutes }}:{{ seconds }}</div>-->
            <!--                  <div class="desc">The price is fixes for 1 hour</div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--              </template>-->
            <!--              <template v-else>-->
            <!--                <div class="card-list__item order-success">-->
            <!--                  <div class="order-submit-success">-->
            <!--                    <div class="order-submit-success__title">Order successfully submitted</div>-->
            <!--                    <div class="order-submit-success__message">-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--              </template>-->
            <!--            </div>-->
          </form>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "CheckoutBuy",
  props: [],
  components: {},
  data: function () {
    return {
      paymentMethod: "visaMastercard",
      wallet: "",
      hours: 1,
      minutes: 0,
      seconds: 0,
      timer: null,
      currentDate: "",
      submitSuccess: false,
      agree: false,
    };
  },
  mounted: function () {
    this.$parent.changeCheckoutSuccess(false);
    this.startTimer();
    this.getCurrentDate();
  },
  methods: {
    getCurrentDate() {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];

      this.currentDate = formattedDate;
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.hours === 0 && this.minutes === 0 && this.seconds === 0) {
          clearInterval(this.timer);
        } else {
          if (this.seconds > 0) {
            this.seconds--;
          } else {
            if (this.minutes > 0) {
              this.minutes--;
              this.seconds = 59;
            } else {
              this.hours--;
              this.minutes = 59;
              this.seconds = 59;
            }
          }
        }
      }, 1000);
    },
    submit() {
      this.$emit("setWallet", this.wallet);
      this.$emit("orderSubmit");
    },
  },
  computed: {
    ...mapGetters("user", ["isVerified", "verificationSubmitted"]),
  },
};
</script>
